import hr from "../assets/logo.png";

export default function Terms() {
  return (
    <div className="w-full">
      <div className="max-w-2xl mx-auto mt-10">
        <img src={hr} alt="image" className="w-16 h-16" />
        <h1 className="mt-2 text-4xl font-bold">HR AI Assistant</h1>
        <p className="text-base text-neutral-400 mt-2">
          Last Updated: 2024-05-13
        </p>
        <div className="details mt-4">
          <p>
            Welcome to HR AI Assistant. These terms and conditions outline the
            rules and regulations for the use of our mobile application ("App").
            By accessing or using the App, you agree to comply with and be bound
            by these terms and conditions. If you do not agree with these terms,
            please do not use the App.
          </p>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">1. Acceptance of Terms</h1>
            <p className="mt-1 ">
              By using the App, you confirm that you have read, understood, and
              agree to these terms and conditions, as well as our Privacy Policy
              and Security Policy.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">2. Use of the App</h1>
            <div className="subsec ml-10">
              <h3 className=" text-xl font-bold mt-2">2.1 License</h3>
              <p className="mt-1 ">
                We grant you a non-exclusive, non-transferable, revocable
                license to use the App for personal, non-commercial purposes,
                subject to these terms and conditions.
              </p>
            </div>

            <div className="subsec ml-10">
              <h3 className=" text-xl font-bold mt-2">2.2 Restrictions</h3>
              <p className="mt-1.5">You agree not to:</p>
              <ul className="list-disc list-outside">
                <li className="ml-5 mt-1">
                  Modify, copy, distribute, transmit, display, perform,
                  reproduce, publish, license, create derivative works from,
                  transfer, or sell any information, software, products, or
                  services obtained from the App.
                </li>
                <li className="ml-5 mt-1">
                  Use the App for any unlawful or prohibited purpose.
                </li>
                <li className="ml-5 mt-1">
                  Attempt to gain unauthorized access to the App, other
                  accounts, computer systems, or networks connected to the App,
                  through hacking, password mining, or any other means.
                </li>
              </ul>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">3. User Account</h1>
            <div className="subsec ml-10">
              <h3 className=" text-xl font-bold mt-2">3.1 Registration</h3>
              <p className="mt-1 ">
                To access certain features of the App, you may be required to
                create an account. You agree to provide accurate and complete
                information during the registration process and to update such
                information as necessary.
              </p>
            </div>

            <div className="subsec ml-10">
              <h3 className=" text-xl font-bold mt-2">3.2 Responsibility</h3>
              <p className="mt-1 ">
                You are responsible for maintaining the confidentiality of your
                account information, including your password, and for all
                activities that occur under your account. You agree to notify us
                immediately of any unauthorized use of your account or any other
                breach of security.
              </p>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">4. Privacy</h1>
            <p className="mt-1 ">
              Your use of the App is also governed by our Privacy Policy, which
              outlines how we collect, use, and protect your personal
              information. By using the App, you consent to the practices
              described in the Privacy Policy.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">5. Intellectual Property</h1>
            <div className="subsec ml-10">
              <h3 className=" text-xl font-bold mt-2">5.1 Ownership</h3>
              <p className="mt-1 ">
                All content included in the App, such as text, graphics, logos,
                images, and software, is the property of HR AI Assistant or its
                content suppliers and is protected by intellectual property
                laws.
              </p>
            </div>

            <div className="subsec ml-10">
              <h3 className=" text-xl font-bold mt-2">5.2 Trademarks</h3>
              <p className="mt-1 ">
                The trademarks, logos, and service marks displayed on the App
                are the property of HR AI Assistant or other third parties. You
                are not permitted to use these marks without the prior written
                consent of HR AI Assistant or the respective third party.
              </p>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">6. Disclaimers</h1>
            <div className="subsec ml-10">
              <h3 className=" text-xl font-bold mt-2">6.1 No Warranty</h3>
              <p className="mt-1 ">
                The App is provided on an "as is" and "as available" basis. We
                make no warranties, expressed or implied, and hereby disclaim
                and negate all other warranties, including without limitation,
                implied warranties or conditions of merchantability, fitness for
                a particular purpose, or non-infringement of intellectual
                property or other violation of rights.
              </p>
            </div>

            <div className="subsec ml-10">
              <h3 className=" text-xl font-bold mt-2">
                6.2 Limitation of Liability
              </h3>
              <p className="mt-1 ">
                In no event shall HR AI Assistant or its suppliers be liable for
                any damages (including, without limitation, damages for loss of
                data or profit, or due to business interruption) arising out of
                the use or inability to use the App, even if HR AI Assistant or
                an authorized representative has been notified orally or in
                writing of the possibility of such damage.
              </p>
            </div>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">7. Indemnification</h1>
            <p className="mt-1 ">
              You agree to indemnify, defend, and hold harmless HR AI Assistant,
              its officers, directors, employees, agents, and third parties, for
              any losses, costs, liabilities, and expenses (including reasonable
              attorneys' fees) relating to or arising out of your use of or
              inability to use the App, any user postings made by you, your
              violation of any terms of this Agreement or your violation of any
              rights of a third party, or your violation of any applicable laws,
              rules or regulations.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">8. Termination</h1>
            <p className="mt-1 ">
              We may terminate or suspend your access to the App immediately,
              without prior notice or liability, for any reason, including if
              you breach these terms and conditions. Upon termination, your
              right to use the App will cease immediately.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">9. Governing Law</h1>
            <p className="mt-1 ">
              These terms and conditions are governed by and construed in
              accordance with the laws of [Your Jurisdiction], and you
              irrevocably submit to the exclusive jurisdiction of the courts in
              that State or location.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">
              10. Changes to Terms and Conditions
            </h1>
            <p className="mt-1 ">
              We may update these terms and conditions from time to time. We
              will notify you of any changes by posting the new terms and
              conditions on this page. You are advised to review these terms
              periodically for any changes. Changes to these terms and
              conditions are effective when they are posted on this page.
            </p>
          </div>

          <div className="mt-4">
            <h1 className="text-2xl font-bold">11. Contact Us</h1>
            <p className="mt-1 ">
              If you have any questions or concerns about these terms and
              conditions, please contact us at:
            </p>
            <p className="mt-1 ">
              Thank you for using HR AI Assistant. We are committed to providing
              a valuable and secure experience.
            </p>
            <p className="mt-2 mailto:font-bold">info@thekaizenglobal.com</p>
          </div>
        </div>
      </div>

      <footer className="w-full mt-10 py-4 bg-neutral-100 text-center">
        <h1>
          All Rights Reserved{" "}
          <a href="https://thekaizenglobal.com/">Kaizen Global</a> 2025
        </h1>
      </footer>
    </div>
  );
}
